import { Button } from '@ksyos/design-system';
import type { IStepProps } from '../OsasPatientQuestionnaire';
import { useViewportWidth } from '../../../../../utils/hooks/useViewportWidth';
import { Paragraph } from '../../../../elements/atoms/paragraph/Paragraph';
import { Container } from '../../../../elements/molecules/container/Container';
import { Hero } from '../../../../elements/molecules/hero/Hero';

export function Intro(props: IStepProps) {
    const { width } = useViewportWidth();

    return (
        <div style={{ margin: '40px 0px' }}>
            <Container isFluidOnMobile>
                <Hero
                    imgUrlDesktop="/assets/images/thuisconsult-home-large.svg"
                    imgUrlMobile="/assets/images/thuisconsult-home-small.svg"
                >
                    <div style={{ marginTop: width < 992 ? '48px' : undefined }}>
                        <Paragraph>
                            We zijn erg benieuwd naar jouw ervaring met Ksyos Slaap. Jouw feedback is erg waardevol voor
                            ons, hiermee kunnen we anderen net als jij nog beter helpen.
                        </Paragraph>
                        <Paragraph>Het kost maar een paar minuten en is volledig anoniem.</Paragraph>
                        <Button
                            color="secondary"
                            onClick={props.validateAndGoToNextStep}
                        >
                            Ga naar de vragen
                        </Button>
                    </div>
                </Hero>
            </Container>
        </div>
    );
}
